import React from 'react';

import { colorOpacity, customTheme } from 'theme';

import { Tag } from 'components/DataDisplay';

export const renderStatusTag = (status: any, bgColor?: string) => {
  if (!status) return '-';
  const styles = color => ({
    bg: !!bgColor ? bgColor : colorOpacity(color, 0.1),
    py: 0.5,
    //color: `white`,
    border: 'none',
  });
  const value = status.toUpperCase();

  const getColor = () => {
    switch (status?.toUpperCase()) {
      case 'SUCCESS':
      case 'SUCCESSFUL':
      case 'COMPLETE':
      case 'COMPLETED':
      case 'SCHEDULED':
      case 'APPROVED':
      case 'ACTIVE':
      case 'PASS':
        return customTheme.colors.green['300'];
      case 'PENDING':
        return customTheme.colors.gray['300'];
      case 'UNAUTHORIZED':
        return customTheme.colors.orange['300'];
      case 'EXPIRED':
        return customTheme.colors.yellow['300'];
      default:
        return customTheme.colors.critical;
    }
  };

  return (
    <Tag
      label={value}
      styles={{ tag: { ...styles(getColor()) }, label: { color: getColor() } }}
    />
  );
};
